import { useEffect } from 'react';
import { useTranslation, useBaseAppConfig } from '@core/hooks';

export const useDocumentTitle = (title: string) => {
  const config = useBaseAppConfig();

  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t(title || '')} - ${config.title}`;
  }, [title]);
};
